import { OrbitProgress } from "react-loading-indicators";

function Loading() {
    return (<div className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.1)] z-50 flex justify-center items-center">
        <OrbitProgress color="#3498db" size="medium" text="" textColor="" />
    </div>
    );
}

export default Loading;